// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ListItemIcon":"bck_a bht_ke","ListItemIcon--empty":"bck_b bht_fl"};